import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { ftpConnectionInitialValue } from 'components/organisms/forms/ftp-connection/FtpConnectionForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiFloppyDisk, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  useGetProviderFtpConnection,
  usePutProviderFtpConnection,
} from 'services/providers/ftp';
import { IProviderFtpConnectionResponse } from 'services/providers/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const EditFtpConnection = () => {
  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const ftpConnection = useGetProviderFtpConnection(providerId, salesChannelId);

  const updateFtpConnection = usePutProviderFtpConnection();
  const mutateOptions = useMutateOptions<IProviderFtpConnectionResponse>();

  const onGoToDetail = () =>
    navigate(
      `/settings/provider/${providerId}/ftp-connection/${salesChannelId}/keys`
    );

  const submitForm = async (
    values: IProviderFtpConnectionResponse,
    helpers: FormikHelpers<IProviderFtpConnectionResponse>
  ) => {
    await updateFtpConnection.mutateAsync(
      {
        ...values,
        salesChannelId: salesChannelId,
        providerId: providerId,
      },
      {
        onSuccess: onGoToDetail,
        ...mutateOptions(helpers),
      }
    );
  };

  return (
    <Form.FtpConnection
      i18nextPrefix='label'
      initialValues={
        ftpConnection.data ? ftpConnection.data : ftpConnectionInitialValue
      }
      onSubmit={submitForm}
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate(
              `/settings/provider/${providerId}/ftp-connection/${salesChannelId}/keys`
            );
          }}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
          <Button.Icon icon={<PiFloppyDisk />} />
        </Button>
      }
      status={{ isLoading: ftpConnection.isLoading }}
    />
  );
};

export default EditFtpConnection;
